import { ChangeEvent, FC, useCallback } from 'react';
import { useField } from 'react-final-form';

import {
  Switch,
  SwitchProps,
} from '@beeline/design-system-react/extracted-styles';

export interface FormSwitchProps extends Omit<SwitchProps, 'value'> {
  name: string;
}

export const FormSwitch: FC<FormSwitchProps> = ({
  name,
  onChange,
  ...rest
}) => {
  const { input } = useField(name, { type: 'string' });

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      input.onChange(e.target.checked);
      onChange?.(e);
    },
    [input, onChange],
  );

  return <Switch {...rest} checked={input.value} onChange={handleChange} />;
};
